import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loggedIn: false,
  userData: {},
};

const userData = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserData: (state, actions) => {
      state.loggedIn = true;
      state.userData = actions.payload;
    },
    removeUserData: (state) => {
      state.loggedIn = false;
      state.userData = {};
    },
  },
});

export default userData.reducer;
export const { setUserData, removeUserData } = userData.actions;
